import React from 'react'

import {MenuOption, PopoverMenuItemType} from "./const"
import PopoverMenuHeader from "./popover-menu-header"
import PopoverMenuOption, {PopoverMenuOptionSelectionType} from "./menu-option"
import PopoverMenuSeparator from "./popover-menu-separator"
import PopoverMenu_OptionSettings from "./option-settings";
import PopoverMenuOptionWithCustomPopover from "./option-with-custom-popover/menu-option-with-custom-popover"
import PopoverMenuOptionWithSubmenu from "./option-with-submenu/menu-option-with-submenu";

type Props = {
    className?      : string

    options         : MenuOption[]
    selectionType?  : PopoverMenuOptionSelectionType    // how a selected option is marked - defaults to the checkmark (see selected.styles.scss)

    hidePopover     : callback

    children?       : any       // used when we want build menu with custom html
}

export default function PopoverMenu(props: Props) {


    // CHILDREN MUST BE ON TOP !!! - used in task more for example...

    return (
        <div className={Classes("ui5-popover-menu", props.className)}>

            {/*on top!*/}
            {props.children}

            {_.map(props.options, (option, key)=>{

                switch (option.type) {

                    case PopoverMenuItemType.SETTING  :
                        return <PopoverMenu_OptionSettings key={key} label={option.label} component={option.component} />

                    case PopoverMenuItemType.SEPARATOR  :
                        return <PopoverMenuSeparator key={key}/>

                    case PopoverMenuItemType.HEADER     :
                        return <PopoverMenuHeader key   = {key}
                                                  title = {option.title || option.label}/>

                    case PopoverMenuItemType.SUBMENU :
                        return <PopoverMenuOptionWithSubmenu key={key}
                                                             option={option}/>


                    case PopoverMenuItemType.COMPONENT:
                        return <option.component key={key} />



                    case PopoverMenuItemType.CUSTOM_POPOVER:

                        const menuParams : any = option.menuParams || {}
                        menuParams['hidePopover'] = props.hidePopover

                        return <PopoverMenuOptionWithCustomPopover key          = {key}
                                                                   option       = {option}
                                                                   disabled     = {option.disabled}
                                                                   menuParams   = {menuParams}/>

                    default:
                        return (
                            <PopoverMenuOption
                                key             = {key}
                                option          = {option}
                                selectionType   = {props.selectionType}
                                checkPro        = {option.isPro}
                                onClickUpgrade  = {option.onClickUpgrade}
                                hidePopover     = {props.hidePopover}
                            />
                        )
                }
            })}
        </div>
    )
}
